var React = require('react');

function UpgradeStar (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","rx":"4","fill":"#E9A944","key":0}),React.createElement("path",{"d":"M10.0007 13.333L6.08208 15.3931L6.83046 11.0297L3.66027 7.93956L8.04137 7.30295L10.0007 3.33301L11.9599 7.30295L16.341 7.93956L13.1708 11.0297L13.9192 15.3931L10.0007 13.333Z","fill":"white","key":1})]);
}

UpgradeStar.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = UpgradeStar;

UpgradeStar.default = UpgradeStar;
